import alertDetail from './alertDetail';
import alertList from './alertList';
import alertListReducer from './alertListReducer';
import auth from './auth';
import {combineReducers} from 'redux';
import credit from './credit';
import {reducer as formReducer} from 'redux-form';
import locks from './locks';
import logout from './logout';
import modal from './modal';
import onboarding from './onboardingDashboard';
import otp from './otp';
import scroll from './scroll';
import tabs from './tabs';
import partner from './partner';
import transactions from './transactionReducers';

let rootReducer: any;

/**
 * Returns result of combining default reducers with async reducers
 * @param asyncReducers hash of name=>reducer pairs
 * @returns {Reducer<any>}
 */
type AsyncReducers = Record<string, unknown>;

export default function createReducer(asyncReducers: AsyncReducers) {
  rootReducer = combineReducers({
    alertListReducer,
    auth,
    credit,
    tabs,
    modal,
    alertList,
    alertDetail,
    logout,
    onboarding,
    locks,
    otp,
    transactions,
    scroll,
    partner,
    form: formReducer,
    ...asyncReducers,
  });
  return rootReducer;
}
export type RootState = ReturnType<typeof rootReducer>;
